
export const baseUrl = 'https://www.websal.com/api/autoconsulta/'
// export const baseUrl = 'http://localhost:8070/https://www.websal.com/api/autoconsulta/'

 export const baseUrlback = 'https://www.websal.com/fdprog/'

// export const baseUrl = 'https://desarrollo.websal.com/rem/api/autoconsulta/'

// export const baseUrlback = 'http://localhost:8082/'


export const backMfa = 'https://www.websal.com/mfa/'



// http://localhost:8070/